<template>

  <div class="profiles-container">
    <div v-for="(profile, index) in profiles" :key="profile.token" class="profile-item flex py-4 px-4 cursor-pointer">
      
      <div class="list-item-body flex-grow-1 login-list-item-body">
        <small class="list-item-text second-item-text remove" @click="remove(profile.token)">
          {{ $t('Remove') }}
        </small>
        
        <small class="list-item-text first-item-text login" v-if="!checkCurrentUser(profile)" @click="switchAccount(profile.token)">
          {{ $t('Login') }}
        </small>
        <small class="list-item-text first-item-text login current" v-else>
          {{ $t('Current') }}
        </small>
      </div>

      <div class="list-item-body flex-grow-1 profile-list-item-body">
        <p class="media-heading">{{ profile.name }}</p>
        <p class="media-email">{{ profile.email }}</p>
      </div>

    </div>
  </div>

</template>

<script>
import gTag from "@/mixins/gtag.js";
import axios from "axios";

export default {
  mixins: [gTag],
  props: {
    isCurrentUser: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      profiles: JSON.parse(localStorage.getItem('profiles')) || [],
    };
  },
  mounted() {
    this.fetchProfiles();
  },
  methods: {
    switchAccount(token) {
      const profile = this.profiles.find(profile => profile.token === token);
      localStorage.setItem("restored", profile.restored);
      localStorage.setItem("walkthrough", profile.walkthrough);
      localStorage.setItem("userData", JSON.stringify(profile));
      window.location.reload();
    },
    async remove(token) {
      await axios.post('logout', {}, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      this.profiles = this.profiles.filter(profile => profile.token !== token);
      localStorage.setItem('profiles', JSON.stringify(this.profiles));
      let userData = localStorage.getItem("userData");
      if(userData.token === token){
        localStorage.removeItem("userData")
        localStorage.removeItem("walkthrough")
        this.$router.push({name:'page-login'})
      }
    },
    checkCurrentUser(profile) {
      return this.isCurrentUser(profile);
    },
    fetchProfiles() {
      this.profiles = JSON.parse(localStorage.getItem('profiles')) || []
    },
  }
};
</script>

<style scoped>
.profile-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid #eee;
  height: auto;
  transition: background-color 0.3s;
}

.profile-item:hover {
  background-color: #f1f1f1;
}

.profile-item:last-child {
  border-bottom: none;
}

.media-heading {
  font-weight: bold;
}

.media-email {
  color: #666;
}

.list-item-text {
  cursor: pointer;
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
}

.first-item-text.login {
    background-color: #4f2f4c;
    color: white !important;
    left: 10px;
    top: 28px;
    margin: 10px;
    border: 1px solid #4f2f4c;
}
.first-item-text.current {
    background-color: green;
    border: 1px solid green;
}

.second-item-text.remove {
  color: red !important;
  border: 1px solid red;
}


.profile-item:hover .media-heading,
.profile-item:hover .media-email,
.profile-item:hover .first-item-text.login,
.profile-item:hover .second-item-text.remove {
  color: #333;
}

.profiles-container{
  width: 100%;
  margin: 30px auto 0 auto;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #f0f0f0;
}

.profile-list-item-body{
  text-align: right;
}
</style>
